import Get from '@/http/Get';
import Post from '@/http/Post';

/**
 * http请求
 */
export default class Http {
  private Get = new Get();
  private Post = new Post();

  async get(url: string, data: any | null = null) {
    return this.Get.request(url, data);
  }

  async post(url: string, data: any | null = null) {
    return this.Post.request(url, data);
  }

  async login(body: { account: string, password: string }) {
    return this.post('login/adminUser', body);
  }

  async addJingLin(data:any) {
    return this.post('/admin/jingling/add', data);
  }
  async editJingLin(data:any) {
    return this.post('/admin/jingling/edit', data);
  }

  async getJingLingList(search: any) {
    return this.get('/admin/jingling/list', search);
  }



  async addJingDian(data:any) {
    return this.post('/admin/jingdian/add', data);
  }
  async editJingDian(data:any) {
    return this.post('/admin/jingdian/edit', data);
  }

  async getJingDianList(search: any) {
    return this.get('/admin/jingdian/list', search);
  }

  async getDetail() {
    return this.get('/admin/getDetail');
  }

  async editUser(data:any) {
    return this.post('/admin/editUser',data);
  }

  async deletedJingDian(data: { id: number }) {
    return this.post('/admin/jingdian/deleted', data);
  }



  async deletedJingLing(data: { id: number }) {
    return this.post('/admin/jingling/deleted', data);
  }
  async getJingDianDetail(search: any) {
    return this.get('/admin/jingdian/detail', search);
  }


  async getOrderList(search: { deleted: number; ps: number; name: string; pi: number; startTag: string }) {
    return this.get('/admin/getOrderList', search);
  }

  async getJiFenDuiHuanList(search:any) {
    return this.get('/admin/getJiFenDuiHuanList', search);
  }


  async deletedShop(data: { id: number }) {
    return this.post('/admin/deleteShop', data);
  }

  async getJinlingDetail(data: { id: number }) {
    return this.get('/admin/jingling/detail', data);
  }
  async changeStatus(data: { id: number,status:number }) {
    return this.post('/admin/editShopStatus', data);
  }

  async hexiaoOrder(data: { id: number }) {
    return this.post('/admin/hexiaoOrder', data);
  }

  async shenheJifenDuiHuan(data:any) {
    return this.post('/admin/shenheJifenDuiHuan', data);
  }


  async getShopDownList() {
    return this.get('/admin/getShopDownList');
  }

  async addTask(data:any) {
    return this.post('/admin/addTask', data);
  }

  async getTaskList(search: any) {
    return this.get('/admin/getTaskList', search);
  }

  async deletedTask(data: { id: number }) {
    return this.post('/admin/deleteTask', data);
  }

  async getTaskListById(data: { id: number }) {
    return this.get('/admin/getTaskListById', data);
  }

  async getAppUserList(search: any) {
    return this.get('/admin/getUserList', search);
  }

  async deletedUser(param: { id: any }) {
    return this.post('/admin/deleteUser', param);
  }

  async addUser(ruleForm: { password: string; name: string; account: string }) {
    return this.post('/admin/addUser', ruleForm);
  }

  async getImageQiNiuUploadToken(data:{suffix:string}) {
    return this.get('/file/imgToken', data,);
  }

  async setSystemInfo (ruleForm: { jifen: number }){
    return this.post('/admin/setSystemInfo', ruleForm);
  }

  async getSystemInfo (){
    return this.get('/admin/getSystemInfo');
  }
}
